// パンくずから機種バリエーションの初期値を判断 No40 2025/12/22
const observer = new MutationObserver(() => {
  const breadcrumbLinks = document.querySelectorAll('.breadcrumb__item .breadcrumb__link');
  let modelName = null;

  breadcrumbLinks.forEach(link => {
    const text = link.textContent.trim();
    const href = link.getAttribute("href") || "";

    if (href.includes("/collections/") && text.includes("フィルム・ガラス")) {
      modelName = text.replace("フィルム・ガラス", "").trim();
    }
    if (href.includes("/collections/") && text.includes("ケース")) {
      modelName = text.replace("ケース", "").trim();
    }
    if (href.includes("/collections/") && text.includes("レンズ保護")) {
      modelName = text.replace("レンズ保護", "").trim();
    }
  });

  if (!modelName) return;

  console.log("抽出されたモデル名:", modelName);

  observer.disconnect(); // 観察終了

  const optionButtons = document.querySelectorAll('.combo-box__option-item[role="option"]');
  if (!optionButtons.length) {
    console.log("コンボボックスのオプションが見つかりません");
    return;
  }

  let found = false;

  for (let btn of optionButtons) {
    const text = btn.textContent.trim();
    if (text === modelName) {
      btn.click();
      console.log(`完全一致バリエーション選択: ${text}`);
      found = true;
      break;
    }
  }

  if (!found) {
    for (let btn of optionButtons) {
      const text = btn.textContent.trim();
      if (text.includes(modelName)) {
        btn.click();
        console.log(`部分一致バリエーション選択: ${text}`);
        found = true;
        break;
      }
    }
  }

  if (!found) {
    console.log(`モデル「${modelName}」に一致するバリエーションが見つかりません`);
  }
});

const breadcrumbRoot = document.querySelector('.breadcrumb') || document.body;
observer.observe(breadcrumbRoot, { childList: true, subtree: true });

console.log("[DEBUG] observer 設定完了:", breadcrumbRoot);